import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';
import { FlatpickrDirective } from 'angularx-flatpickr';
import { German } from 'flatpickr/dist/l10n/de.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';

import { BaseControlComponent } from '~components/form/base-control/base-control.component';
import { FormControlPipe } from '~core/pipes/form-control.pipe';
import { TranslationService } from '~core/services/translation.service';

@Component({
    selector: 'arc-datetime-picker',
    templateUrl: './datetime-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, FlatpickrDirective, TranslocoPipe, FormControlPipe]
})
export class DatetimePickerComponent extends BaseControlComponent implements OnInit {
    min = input<Date>(new Date(1970, 1, 1));
    locale = signal<object | string>('');

    dateFormat = signal('');

    private readonly translationService = inject(TranslationService);

    override ngOnInit(): void {
        super.ngOnInit();
        this.dateFormat.set(this._translationService.current.dateFormatFlatPicker);
        this.locale.set(this.getLocale());
    }

    private getLocale(): object | string {
        switch (this.translationService.current.code) {
            case 'de':
                return German;
            case 'fr':
                return French;
            case 'it':
                return Italian;
            default:
                return 'en';
        }
    }
}
